import { ReactNode } from 'react';

import { HeavyModalCard } from '@ui/components/HeavyModalCard/HeavyModalCard';

import styles from './PlayerEloStats.module.css';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  children?: ReactNode;
};
export function PlayerEloStats({ isOpen, onClose, children }: Props) {
  return (
    <HeavyModalCard header="Рейтинг" open={isOpen} onBack={onClose}>
      <div className={styles.content}>{children}</div>
    </HeavyModalCard>
  );
}
